import { defineComponent as _defineComponent } from 'vue'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue';
import { IDomEditor, IToolbarConfig, IEditorConfig } from '@wangeditor/editor';
import { onBeforeMount, ref, watch } from 'vue';
import oss from 'baimahu/aliyun/oss';
// import { DomEditor } from '@wangeditor/editor';
type InsertFnType = (url: string, alt: string, href: string) => void;


export default /*#__PURE__*/_defineComponent({
  __name: 'NEditor',
  props: {
    toolbarConfig: null,
    toolbarStyle: { default: () => ({
      borderBottom: '1px solid #ccc',
    }) },
    editorConfig: null,
    editorStyle: { default: () => ({
      height: '600px',
    }) },
    mode: { default: 'default' },
    value: null,
    loading: { type: Boolean, default: false },
    disabled: { type: [Boolean, null] }
  },
  emits: ["onCreated", "input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'onCreated', editor: IDomEditor): void;
  (e: 'input', value: string): void;
  /**
   *  除以上emit事件外还支持以下事件 详见https://www.wangeditor.com/v5/for-frame.html#配置
   *   (e:'onChange, editor'):void
   *   (e:'onDestroyed', editor):void
   *   (e:'onMaxLength', editor):void
   *   (e:'onFocus', editor):void
   *   (e:'onBlur', editor):void
   *   (e:'customAlert', info: string, type: string):void
   *   (e:'customPaste', editor, event, callback):void
   */
}), expose: any, slots: any, attrs: any }) {

const props = __props as { toolbarConfig?: Partial<IToolbarConfig>, toolbarStyle: any, editorConfig?: Partial<IEditorConfig>, editorStyle: any, mode: 'default' | 'simple', value?: string, loading: boolean, disabled?: boolean | undefined };

const { VUE_APP_API: API } = process.env;

const defaultEditorConfig: Partial<IEditorConfig> = {
  MENU_CONF: {
    uploadImage: {
      customUpload(file: File, insertFn: InsertFnType) {
        upload(file).then(res => {
          if (res) {
            insertFn(res?.url, res?.alt, res?.href);
          }
        });
        async function upload(file) {
          const { src } = await oss.upload(`https://${API}/boss/common/oss`, file, true);
          if (src) {
            return {
              url: 'https:' + src,
              alt: file.name,
              href: 'https:' + src,
            };
          }
        }
      },
    },
  },
  placeholder: '请输入内容...',
};
const defaultToolbarConfig = {
  toolbarKeys: [
    'headerSelect',
    'blockquote',
    '|',
    'bold',
    'underline',
    'italic',
    {
      key: 'group-more-style',
      title: '更多',
      iconSvg:
        '<svg viewBox="0 0 1024 1024"><path d="M204.8 505.6m-76.8 0a76.8 76.8 0 1 0 153.6 0 76.8 76.8 0 1 0-153.6 0Z"></path><path d="M505.6 505.6m-76.8 0a76.8 76.8 0 1 0 153.6 0 76.8 76.8 0 1 0-153.6 0Z"></path><path d="M806.4 505.6m-76.8 0a76.8 76.8 0 1 0 153.6 0 76.8 76.8 0 1 0-153.6 0Z"></path></svg>',
      menuKeys: ['through', 'code', 'sup', 'sub', 'clearStyle'],
    },
    'color',
    'bgColor',
    '|',
    'fontSize',
    'fontFamily',
    'lineHeight',
    '|',
    'bulletedList',
    'numberedList',
    'todo',
    {
      key: 'group-justify',
      title: '对齐',
      iconSvg:
        '<svg viewBox="0 0 1024 1024"><path d="M768 793.6v102.4H51.2v-102.4h716.8z m204.8-230.4v102.4H51.2v-102.4h921.6z m-204.8-230.4v102.4H51.2v-102.4h716.8zM972.8 102.4v102.4H51.2V102.4h921.6z"></path></svg>',
      menuKeys: ['justifyLeft', 'justifyRight', 'justifyCenter', 'justifyJustify'],
    },
    {
      key: 'group-indent',
      title: '缩进',
      iconSvg:
        '<svg viewBox="0 0 1024 1024"><path d="M0 64h1024v128H0z m384 192h640v128H384z m0 192h640v128H384z m0 192h640v128H384zM0 832h1024v128H0z m0-128V320l256 192z"></path></svg>',
      menuKeys: ['indent', 'delIndent'],
    },
    '|',
    'emotion',
    'insertLink',
    {
      key: 'group-image',
      title: '图片',
      iconSvg:
        '<svg viewBox="0 0 1024 1024"><path d="M959.877 128l0.123 0.123v767.775l-0.123 0.122H64.102l-0.122-0.122V128.123l0.122-0.123h895.775zM960 64H64C28.795 64 0 92.795 0 128v768c0 35.205 28.795 64 64 64h896c35.205 0 64-28.795 64-64V128c0-35.205-28.795-64-64-64zM832 288.01c0 53.023-42.988 96.01-96.01 96.01s-96.01-42.987-96.01-96.01S682.967 192 735.99 192 832 234.988 832 288.01zM896 832H128V704l224.01-384 256 320h64l224.01-192z"></path></svg>',
      menuKeys: ['insertImage', 'uploadImage'],
    },
    'insertVideo',
    'insertTable',
    'codeBlock',
    'divider',
    '|',
    'undo',
    'redo',
  ],
};


const editData = ref<string>(props.value || '');

const editor = ref<IDomEditor | null>(null);
function onCreated(_editor: IDomEditor) {
  editor.value = _editor;
  //获取工具栏对象 可用使用以下代码
  //const toolbar = DomEditor.getToolbar(_editor);
  emit('onCreated', _editor);
}
onBeforeMount(()=>{
  watch(editData, (newValue, oldValue) => {
  if (editor.value && editor.value?.isEmpty()) {
    emit('input', '');
    return;
  }
  emit('input', newValue);
});
watch(
  () => props.value,
  () => {
    if (props.value==''&&editor.value?.isEmpty()) {
      return;
    }
    if (props.value !== editData.value) {
      editData.value = props.value || '';
      return
    }
    if (editor.value?.isEmpty()) {
      emit('input', props.value||'');
      return;
    }

  },
  {
    immediate: true,
  }
);
watch(
  () => [props?.disabled, !editor.value],
  () => {
    if (!editor.value) return;
    if (props.disabled === true) {
      editor.value.disable();
    }
    if (props.disabled === false) {
      editor.value.enable();
    }
  },
  {
    immediate: true,
  }
);
})


// defineExpose({
//   defaultEditorConfig,
//   defaultToolbarConfig,
// });

return { __sfc: true,API, defaultEditorConfig, defaultToolbarConfig, props, emit, editData, editor, onCreated, Editor, Toolbar }
}

})